import Settings from './UserSettings';

export default Settings;
